import { createBar } from "./bars.js";

export interface TargetInfo {
  name: string;
  health: number;
  maxHealth: number;
}

export interface TargetFrame {
  element: HTMLElement;
  /** Pass undefined when nothing resolves; the frame lingers briefly, then hides. */
  update(target: TargetInfo | undefined, now: number): void;
}

const LINGER_MS = 2500;

export function createTargetFrame(): TargetFrame {
  const element = document.createElement("div");
  element.className = "target-frame";

  const name = document.createElement("div");
  name.className = "target-frame-name";

  const health = createBar("health");
  element.append(name, health.element);

  let lastSeenAt = 0;

  return {
    element,
    update: (target, now) => {
      if (target) {
        lastSeenAt = now;
        name.textContent = target.name;
        health.set(target.health, target.maxHealth);
      }
      element.classList.toggle("is-visible", now - lastSeenAt < LINGER_MS);
    },
  };
}
